import * as Yup from "yup";

export const ResetPasswordSchema = Yup.object().shape({
  new_password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("New Password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("new_password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});
